(function () {
  'use strict';

  var GOOGLE_ADS_ID = 'AW-18031615333';
  var GOOGLE_ADS_SEND_TO = 'AW-18031615333/jlQICMeV844cEOW6kpZD';
  var SESSION_STATUS_URL = 'https://pmp-stripe-bridge.vercel.app/api/session-status';
  var ORIGINAL_ASSET = 'pmp-uniform-hotfix-google-base-20260808.js';
  var ATTRIBUTION_STORAGE_KEY = 'pmp_paid_attribution_v3';
  var LAST_TOUCH_STORAGE_KEY = 'pmp_last_touch_v1';
  var ATTRIBUTION_TTL_MS = 90 * 24 * 60 * 60 * 1000;
  var ATTRIBUTION_KEYS = [
    'fbclid', 'gclid', 'gbraid', 'wbraid', 'ttclid', 'msclkid',
    'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'
  ];
  var PAID_CLICK_KEYS = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'ttclid', 'msclkid'];
  var PAID_MEDIUM_PATTERN = /^(cpc|ppc|paid|paidsocial|paid[-_ ]?social|paid[-_ ]?search|display|retargeting|remarketing)$/i;
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  function safeParameter(name, value) {
    var clean = String(value == null ? '' : value).trim();
    if (!clean || clean.length > 500) return null;
    var lowered = clean.toLowerCase();
    if (
      lowered === name.toLowerCase() ||
      lowered === 'null' ||
      lowered === 'undefined' ||
      /^\{\{.*\}\}$/.test(clean) ||
      /^\{.*\}$/.test(clean)
    ) return null;
    return clean;
  }

  // Attribution ranking. 2 = paid click (ad click id or explicitly paid medium),
  // 1 = non paid campaign tagging (newsletter, email, organic social...),
  // 0 = no campaign signal at all. A weaker signal never replaces a stronger one.
  function attributionTier(record) {
    if (!record || typeof record !== 'object') return 0;
    for (var i = 0; i < PAID_CLICK_KEYS.length; i += 1) {
      if (record[PAID_CLICK_KEYS[i]]) return 2;
    }
    if (record.utm_medium && PAID_MEDIUM_PATTERN.test(String(record.utm_medium).trim())) return 2;
    for (var j = 0; j < UTM_KEYS.length; j += 1) {
      if (record[UTM_KEYS[j]]) return 1;
    }
    return 0;
  }

  function approvedAttributionUrl(currentUrl, params) {
    try {
      var current = new URL(currentUrl, window.location.href);
      current.hash = '';
      current.search = '';
      ATTRIBUTION_KEYS.forEach(function (key) {
        var value = safeParameter(key, params.get(key));
        if (value) current.searchParams.set(key, value);
      });
      return current.toString();
    } catch (_) {
      return String(currentUrl || '').slice(0, 1200);
    }
  }

  function readStoredAttribution() {
    try {
      var record = JSON.parse(window.localStorage.getItem(ATTRIBUTION_STORAGE_KEY) || 'null');
      if (!record || typeof record !== 'object') return null;
      var capturedAt = Number(record.captured_at) || 0;
      if (!capturedAt || Date.now() - capturedAt > ATTRIBUTION_TTL_MS) {
        window.localStorage.removeItem(ATTRIBUTION_STORAGE_KEY);
        return null;
      }
      return record;
    } catch (_) {
      return null;
    }
  }

  function cookieValue(name) {
    var escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + escaped + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function writeFbc(fbclid, capturedAt) {
    if (!fbclid || cookieValue('_fbc')) return;
    var fbc = 'fb.1.' + String(Number(capturedAt) || Date.now()) + '.' + fbclid;
    try {
      document.cookie =
        '_fbc=' + encodeURIComponent(fbc) +
        '; Max-Age=7776000; Path=/; SameSite=Lax; Secure';
    } catch (_) {}
  }

  function captureAttributionEarly() {
    var currentUrl = window.location.href;
    var referrer = document.referrer || '';
    var params;
    try {
      params = new URL(currentUrl).searchParams;
    } catch (_) {
      params = new URLSearchParams(window.location.search);
    }

    var values = {};
    ATTRIBUTION_KEYS.forEach(function (key) {
      var value = safeParameter(key, params.get(key));
      if (value) values[key] = value;
    });

    var hasCurrentCampaignSignal = Object.keys(values).length > 0;
    var stored = readStoredAttribution();
    var incomingTier = attributionTier(values);
    var storedTier = attributionTier(stored);
    var selected = null;
    var source = 'current-session';
    var storedRecordReplaced = false;

    if (hasCurrentCampaignSignal) {
      var candidate = {
        landing_url: approvedAttributionUrl(currentUrl, params),
        referrer: referrer,
        captured_at: Date.now()
      };
      Object.keys(values).forEach(function (key) { candidate[key] = values[key]; });

      if (!stored || incomingTier >= storedTier) {
        // Same or stronger signal: last paid click wins and fully replaces the record.
        selected = candidate;
        storedRecordReplaced = true;
        try {
          window.localStorage.setItem(ATTRIBUTION_STORAGE_KEY, JSON.stringify(candidate));
        } catch (_) {}
        source = 'new-campaign-click';
      } else {
        // Weaker signal (newsletter, email, organic social...) must never erase a
        // paid click. It is kept aside as a last touch for reporting only.
        selected = stored;
        try {
          window.localStorage.setItem(LAST_TOUCH_STORAGE_KEY, JSON.stringify(candidate));
        } catch (_) {}
        source = 'kept-paid-click';
      }
    } else {
      try {
        var sessionLanding = window.sessionStorage.getItem('pmp_landing_url');
        var sessionReferrer = window.sessionStorage.getItem('pmp_first_referrer');
        if (sessionLanding) {
          selected = {
            landing_url: sessionLanding,
            referrer: sessionReferrer || '',
            captured_at: Date.now()
          };
          source = 'existing-session';
        }
      } catch (_) {}

      if (!selected && stored && stored.landing_url) {
        selected = stored;
        source = 'restored-paid-click';
      }

      if (!selected) {
        selected = {
          landing_url: approvedAttributionUrl(currentUrl, new URLSearchParams()),
          referrer: referrer,
          captured_at: Date.now()
        };
        source = 'new-organic-session';
      }
    }

    try {
      // Only a click that actually replaced the stored record may reset the session
      // landing url. Empty, internal or weaker pages never erase an existing record.
      if (
        storedRecordReplaced ||
        !window.sessionStorage.getItem('pmp_landing_url')
      ) {
        window.sessionStorage.setItem('pmp_landing_url', selected.landing_url || currentUrl);
        window.sessionStorage.setItem('pmp_first_referrer', selected.referrer || '');
      }
    } catch (_) {}

    var fbclid = values.fbclid || (stored && safeParameter('fbclid', stored.fbclid));
    writeFbc(fbclid, selected.captured_at);

    window.__pmpAttributionCapture = {
      version: 'pmp_attr_v3_1',
      source: source,
      hasCampaignSignal: hasCurrentCampaignSignal,
      incomingTier: incomingTier,
      storedTier: storedTier,
      storedRecordReplaced: storedRecordReplaced,
      hasFbclid: Boolean(values.fbclid || (stored && stored.fbclid)),
      hasGoogleClickId: Boolean(
        values.gclid || values.gbraid || values.wbraid ||
        (stored && (stored.gclid || stored.gbraid || stored.wbraid))
      ),
      hasTikTokClickId: Boolean(values.ttclid || (stored && stored.ttclid)),
      landingPath: (function () {
        try { return new URL(selected.landing_url, currentUrl).pathname; }
        catch (_) { return null; }
      })()
    };
  }

  // This must run before any Add to Cart navigation. The checkout code reads
  // these sessionStorage keys later, after the shopper may already be on /cart.
  captureAttributionEarly();
  window.addEventListener('pageshow', captureAttributionEarly);


  (function installBundleSummaryPriceSync() {
    if (window.__pmpBundleSummaryPriceSyncInstalled) return;
    window.__pmpBundleSummaryPriceSyncInstalled = true;

    function syncBundleSummaryPrices() {
      document.querySelectorAll('[data-pmp-product-bundles]').forEach(function (bundleGroup) {
        var selected = bundleGroup.querySelector('input[name="pmp_product_bundle"]:checked');
        var flow = bundleGroup.closest('.pmp-purchase-flow');
        var label = selected ? selected.closest('label') : null;
        var price = label ? label.querySelector('.pmp-y4-bundle__price strong') : null;
        var summary = flow ? flow.querySelector('[data-pmp-summary-total]') : null;
        var formattedPrice = price ? price.textContent.trim() : '';

        if (summary && formattedPrice && summary.textContent.trim() !== formattedPrice) {
          summary.textContent = formattedPrice;
        }
      });
    }

    function startBundleSummaryPriceSync() {
      syncBundleSummaryPrices();
      if (!document.body) return;
      new MutationObserver(syncBundleSummaryPrices).observe(document.body, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    document.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches('input[name="pmp_product_bundle"]')) return;
      syncBundleSummaryPrices();
      window.requestAnimationFrame(syncBundleSummaryPrices);
      window.setTimeout(syncBundleSummaryPrices, 0);
    }, true);
    window.addEventListener('pageshow', syncBundleSummaryPrices);
    window.__pmpSyncBundleSummaryPrices = syncBundleSummaryPrices;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startBundleSummaryPriceSync, { once: true });
    } else {
      startBundleSummaryPriceSync();
    }
  })();

  // Preserve every pre-existing storefront correction. This wrapper loads the
  // copied original asset, then adds Google Ads tracking independently.
  (function loadOriginalHotfix() {
    if (window.__pmpOriginalHotfixRequested) return;
    window.__pmpOriginalHotfixRequested = true;

    try {
      var current = document.currentScript || document.querySelector('script[src*="pmp-uniform-hotfix.js"]');
      if (!current || !current.src) throw new Error('Current hotfix script URL not found');
      var originalUrl = new URL(current.src, window.location.href);
      originalUrl.pathname = originalUrl.pathname.replace(/pmp-uniform-hotfix\.js$/, ORIGINAL_ASSET);
      originalUrl.search = '';

      var original = document.createElement('script');
      original.src = originalUrl.toString();
      original.async = false;
      original.dataset.pmpOriginalHotfix = 'true';
      original.onload = function () { window.__pmpOriginalHotfixLoaded = true; };
      original.onerror = function () {
        try { console.error('PMP original storefront hotfix failed to load'); } catch (_) {}
      };
      document.head.appendChild(original);
    } catch (error) {
      try { console.error('PMP original storefront hotfix loader failed', error); } catch (_) {}
    }
  })();

  if (window.__pmpGoogleAdsTrackingInstalled) return;
  window.__pmpGoogleAdsTrackingInstalled = true;

  function isThankYouPage() {
    return /(^|\/)(pages\/)?thank-you(\/|$)/.test(window.location.pathname);
  }

  var sessionId = null;
  if (isThankYouPage()) {
    sessionId = new URLSearchParams(window.location.search).get('session_id');
    if (!sessionId || !/^cs_[A-Za-z0-9_]+$/.test(sessionId)) sessionId = null;
  }

  window.dataLayer = window.dataLayer || [];
  var previousGtag = typeof window.gtag === 'function'
    ? window.gtag
    : function () { window.dataLayer.push(arguments); };

  var statusPromise = sessionId
    ? fetch(SESSION_STATUS_URL + '?session_id=' + encodeURIComponent(sessionId), {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        cache: 'no-store',
        keepalive: true
      }).then(function (response) {
        if (!response.ok) throw new Error('Stripe payment verification failed');
        return response.json();
      })
    : Promise.resolve(null);

  var pendingConversions = {};
  function sendVerifiedConversion(requestedData) {
    if (!sessionId) {
      previousGtag('event', 'conversion', requestedData || {});
      return;
    }

    var transactionId = String((requestedData && requestedData.transaction_id) || sessionId);
    if (pendingConversions[transactionId]) return;
    pendingConversions[transactionId] = true;

    var storageKey = 'pmp_google_ads_conversion_' + transactionId;
    try {
      if (window.localStorage.getItem(storageKey)) return;
    } catch (_) {}

    statusPromise.then(function (data) {
      if (!data || !data.paid) return;

      if (data.google_user_data && typeof data.google_user_data === 'object') {
        previousGtag('set', 'user_data', data.google_user_data);
      }

      var payload = {};
      Object.keys(requestedData || {}).forEach(function (key) { payload[key] = requestedData[key]; });
      payload.send_to = GOOGLE_ADS_SEND_TO;
      payload.value = (Number(data.amount) || 0) / 100;
      payload.currency = String(data.currency || 'USD').toUpperCase();
      payload.transaction_id = sessionId;

      previousGtag('event', 'conversion', payload);
      window.dataLayer.push({
        event: 'pmp_google_ads_purchase_sent',
        transaction_id: sessionId,
        value: payload.value,
        currency: payload.currency,
        enhanced_conversion_data: Boolean(data.google_user_data)
      });

      try { window.localStorage.setItem(storageKey, '1'); } catch (_) {}
    }).catch(function (error) {
      delete pendingConversions[transactionId];
      try { console.error('PMP Google Ads conversion was not sent', error); } catch (_) {}
    });
  }

  // Intercept only this store's Purchase conversion. The existing footer script
  // may also request the same conversion; all requests are consolidated into one
  // Stripe-verified event carrying the same transaction ID and enhanced data.
  window.gtag = function () {
    var args = Array.prototype.slice.call(arguments);
    var eventData = args[2];
    if (
      sessionId &&
      args[0] === 'event' &&
      args[1] === 'conversion' &&
      eventData &&
      eventData.send_to === GOOGLE_ADS_SEND_TO
    ) {
      sendVerifiedConversion(eventData);
      return;
    }
    previousGtag.apply(window, args);
  };

  window.__pmpGoogleAdsTracking = {
    version: 'pmp_google_v2',
    conversionId: GOOGLE_ADS_ID,
    conversionDestination: GOOGLE_ADS_SEND_TO,
    stripeSessionId: sessionId,
    statusPromise: statusPromise
  };

  // Load gtag.js only when another Google tag loader has not already done so.
  var hasGoogleTagLoader = false;
  var scripts = document.getElementsByTagName('script');
  for (var i = 0; i < scripts.length; i += 1) {
    if (/googletagmanager\.com\/gtag\/js/i.test(String(scripts[i].src || ''))) {
      hasGoogleTagLoader = true;
      break;
    }
  }
  if (!hasGoogleTagLoader) {
    var googleTag = document.createElement('script');
    googleTag.async = true;
    googleTag.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(GOOGLE_ADS_ID);
    googleTag.dataset.pmpGoogleAdsTag = 'true';
    document.head.appendChild(googleTag);
  }

  if (!window.__pmpGoogleAdsConfigured) {
    window.__pmpGoogleAdsConfigured = true;
    window.gtag('js', new Date());
    window.gtag('config', GOOGLE_ADS_ID);
  }

  // Explicitly request the Purchase conversion. If another script requests it as
  // well, the interceptor above still sends it only once.
  if (sessionId) {
    sendVerifiedConversion({
      send_to: GOOGLE_ADS_SEND_TO,
      transaction_id: sessionId
    });
  }
})();
